const HospitalDetails = {
  hospitalName: "Curative Physio Clinic",
  hospitalEmail: "curative.physiotherapy.clinic@gmail.com",
  hospitalPhone: "+91 9693631008",
  hospitalPhone2: "+91 9693631008",
  hospitalAddress:"Patel janta nagar Bhagwat nagar main road patna 26 Landmark:- Near Bhagwat Milan banquet"
};

export default HospitalDetails;
